<div class="page-not-found">
  <h1>404</h1>
  <p>Página não encontrada</p>
  <a (click)="goBack()" style="cursor: pointer">Voltar para a página anterior</a>
</div>
